import { render, staticRenderFns } from "./ItemCreateSaveLayout.vue?vue&type=template&id=16843215&scoped=true"
import script from "./ItemCreateSaveLayout.vue?vue&type=script&lang=js"
export * from "./ItemCreateSaveLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16843215",
  null
  
)

export default component.exports